module.exports = __webpack_public_path__ + "img/9788901088532.1228ea9a.jpg";